import { camelCase, isArray, isObject, isPlainObject, map, mapKeys, mapValues } from 'es-toolkit/compat';

export const normalizeKeysToCamelCase = <T>(value: T): T => {
  if (isArray(value)) {
    return map(value, (item) => normalizeKeysToCamelCase(item)) as T;
  }

  if (!isObject(value) || !isPlainObject(value)) {
    return value;
  }

  const normalizedKeys = mapKeys(value as Record<string, unknown>, (_fieldValue, fieldKey) => camelCase(fieldKey));
  return mapValues(normalizedKeys, (fieldValue) => normalizeKeysToCamelCase(fieldValue)) as T;
};
